const ANALYTICS_OWNER_IDENTITY = 'postmaster@analytics.msging.net';
const BOTANALYTICS_URL = 'https://api.botanalytics.co/v1/webhooks/blip/';
import { BOTANALYTICS_ACTIVE } from '../IntegrationsController';
import './Botanalytics.scss';
import { IntegrationsFeatures } from '../IntegrationsFeatures';
export class BotanalyticsController {
    static $inject = ['LoadingService', 'ConfigurationsService', 'application', 'ngToast', '$translate', 'SegmentService', 'IntegrationsSegmentService', 'IntegrationsService'];
    constructor(LoadingService, ConfigurationsService, application, ngToast, $translate, SegmentService, IntegrationsSegmentService, IntegrationsService) {
        'ngInject';
        this.LoadingService = LoadingService;
        this.ConfigurationsService = ConfigurationsService;
        this.application = application;
        this.ngToast = ngToast;
        this.$translate = $translate;
        this.SegmentService = SegmentService;
        this.IntegrationsSegmentService = IntegrationsSegmentService;
        this.IntegrationsService = IntegrationsService;
        this.onChangeUrl = (event) => {
            const { detail: { value } } = event;
            this.settings['Botanalytics.Token'] = value;
        };
        this.init();
    }
    async init() {
        this.settings = {};
        await this.checkFeatures();
        this.SegmentService.createTrack('integrations-botanalytics-opened', {
            botName: this.application.name,
            botIdentifier: this.application.shortName,
        });
        this.IntegrationsSegmentService.setApplication(this.application);
        await this.fetchConfiguration();
    }
    async checkFeatures() {
        this.isConfigurationsApplicationsDomainUsageGetEnabled = await IntegrationsFeatures.isConfigurationsDomainOnChannelsOperationsGetEnabled();
        this.isConfigurationsApplicationsDomainUsageSetEnabled = await IntegrationsFeatures.isConfigurationsDomainOnChannelsOperationsSetEnabled();
    }
    async fetchConfiguration() {
        try {
            this.LoadingService.startLoading();
            this.settings = await this.ConfigurationsService.get(ANALYTICS_OWNER_IDENTITY, undefined, this.isConfigurationsApplicationsDomainUsageGetEnabled);
            this.isActive =
                this.settings[BOTANALYTICS_ACTIVE].toLowerCase() == 'true'
                    ? true
                    : false;
        }
        finally {
            this.oldSettings = { ...this.settings };
            this.LoadingService.stopLoading();
        }
    }
    async onToggle(value) {
        this.isActive = value;
        this.LoadingService.startLoading();
        try {
            this.settings[BOTANALYTICS_ACTIVE] = this.isActive;
            await this.ConfigurationsService.set(ANALYTICS_OWNER_IDENTITY, this.settings, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled);
            if (this.isActive) {
                this.SegmentService.createTrack('integrate-chatbot', {
                    botName: this.application.name,
                    template: this.application.template,
                    integration: 'Botanalytics',
                });
            }
        }
        catch (e) {
            const errorMsg8 = await this.$translate('utils.errorMsg.10');
            this.ngToast.danger(errorMsg8);
            this.isActive = !this.isActive;
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async save() {
        this.settings['Botanalytics.Url'] = `${BOTANALYTICS_URL}${this.settings['Botanalytics.Token']}`;
        try {
            this.LoadingService.startLoading();
            await this.ConfigurationsService.set(ANALYTICS_OWNER_IDENTITY, this.settings, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled);
            this.afterSave();
            const successMsg8 = await this.$translate('utils.successMsg.8');
            this.ngToast.success(successMsg8);
        }
        catch (err) {
            const errorMsg8 = await this.$translate('utils.errorMsg.10');
            this.ngToast.danger(errorMsg8);
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    afterSave() {
        if (this.isTokenNew()) {
            this.trackConnectionBotanalyticsConfigurationAddSaved();
        }
        else {
            this.trackConnectionBotanalyticsConfigurationChangesSaved(this.IntegrationsService.objectsDifferentKeys(this.settings, this.oldSettings));
        }
        this.oldSettings = { ...this.settings };
    }
    isTokenNew() {
        return this.settings['Botanalytics.Token'] &&
            this.oldSettings['Botanalytics.Token'] === undefined;
    }
    // Segment
    trackConnectionBotanalyticsConfigurationAddSaved() {
        this.IntegrationsSegmentService
            .trackConnectionBotanalyticsConfigurationAddSaved({
            Token: this.settings['Botanalytics.Token'],
        });
    }
    trackConnectionBotanalyticsConfigurationChangesSaved(changedFields) {
        this.IntegrationsSegmentService
            .trackConnectionBotanalyticsConfigurationChangesSaved({
            ChangedFields: changedFields,
        });
    }
}
BotanalyticsController.$inject = ['LoadingService', 'ConfigurationsService', 'application', 'ngToast', '$translate', 'SegmentService', 'IntegrationsSegmentService', 'IntegrationsService'];
